import styled from '@emotion/styled'
import { Button } from '../Controls'
import { BsCart2 } from 'react-icons/bs'

interface Props {
  closeModal: (modalName: string) => void
}

const EmptyCartState = ({ closeModal }: Props) => {
  return (
    <EmptyCartContainer>
      <CartIcon size='24px' />
      <EmptyCartText>Your Cart is empty</EmptyCartText>
      <Button onClick={() => closeModal('cart')}>View Menu</Button>
    </EmptyCartContainer>
  )
}

const EmptyCartText = styled.p(({ theme }) => ({
  color: theme.colors.black,
  fontSize: theme.fontSizes[2],
  fontWeight: 500,
  marginBottom: '60px'
}))

const EmptyCartContainer = styled.div(() => ({
  margin: '35% 15% 0',
  textAlign: 'center' as const,
  maxWidth: '350px',
  justifyContent: 'center' as const,
  alignItems: 'center' as const,
  display: 'flex' as const,
  alignContent: 'center' as const,
  flexDirection: 'column' as const
}))

const CartIcon = styled(BsCart2)(() => ({
  width: '80px',
  height: '80px'
}))

export default EmptyCartState
